import { render, staticRenderFns } from "./DefaultTeams.vue?vue&type=template&id=4a26b438&"
import script from "./DefaultTeams.vue?vue&type=script&lang=ts&"
export * from "./DefaultTeams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports